import { createInput } from '@formkit/vue'
import type { FormKitInputs } from '@formkit/inputs'
import WeekdayPercentageInput from '../../components/WeekdayPercentageInput/index.vue'

export const weekdayPercentageInput = createInput(WeekdayPercentageInput)

declare module '@formkit/inputs' {
  interface FormKitInputProps<Props extends FormKitInputs<Props>> {
    weekdayPercentage: {
      type: 'weekdayPercentage'
    }
  }
}
